module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0067.jpg?v=e1f78700";